import styled from "@yb/styled-px2rem";

const Wrap = styled.div`
	display: flex;
	align-items: flex-start;
	gap: 4px;
	line-height: 1;

	img {
		width: 15px;
		height: 15px;
		margin-top: -1px;
	}
`;

const AirlineIcon = ({title, img, classes}: {title: string; img: string; classes?: string}) => (
	<Wrap>
		<img src={img} alt={title} />
		<span>
			{title}
			<br />
			{classes && <>&#40;{classes}&#41;</>}
		</span>
	</Wrap>
);

export default AirlineIcon;
